module.exports = __webpack_public_path__ + "img/12.62564149.webp";